// ABOUTME: Subtle top-level feedback icon component for universal user feedback collection
// ABOUTME: Opens FeedbackModal when clicked, positioned in top-left corner on all pages
import React from 'react';
import './FeedbackButton.css';

const FeedbackButton = ({ onClick }) => {
  return (
    <button
      className="feedback-button"
      onClick={onClick}
      aria-label="Enviar feedback"
      title="Enviar feedback sobre sua experiência"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Message bubble icon */}
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    </button>
  );
};

export default FeedbackButton;
